export default function GravityFormsTracking () {

  const forms = document.querySelectorAll('form[data-form-title]')

  const formTitles = Array.from(forms).map(form => {
    return {
      id: form.getAttribute('data-formid'),
      title: form.getAttribute('data-form-title'),
    }
  })

  jQuery(document).on('gform_confirmation_loaded', (event, formId) => {
    let formTitle = ''

    if (formTitles.length > 0) {
      const form = formTitles.find(f => f.id === formId.toString())
      if (form) {
        formTitle = form.title
      }
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': 'form_submission',
      'form_id': formId,
      'form_title': formTitle || 'Unknown Form',
      'page_url': window.location.href,
    })
  })
}
